<template>
    <section>
      <el-dialog
        title="终端配置"
        :visible.sync="addFormVisible"
        v-model="addFormVisible"
        :close-on-click-modal="false"
        :before-close="closetc"
      >
        <el-form
          :model="addForm"
          label-width="120px"
          :rules="addFormRules"
          ref="addForm"
        >
          <el-form-item label="机器编号" prop="MachineNO">
            <el-input v-model="editForm.MachineNO" auto-complete="off" readonly="readonly"></el-input>
          </el-form-item>

          <el-form-item label="是否需要分屏" prop="Seperate">
            <el-radio-group v-model="addForm.Seperate">
              <el-radio-button label="1">是</el-radio-button>
              <el-radio-button label="0">否</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="分屏方式" prop="SeperateType">
            <el-radio-group v-model="addForm.SeperateType">
              <el-radio-button label="1">上下</el-radio-button>
              <el-radio-button label="0">左右</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="默认分屏方式" prop="DefaultSeperate">
            <el-radio-group v-model="addForm.DefaultSeperate">
              <el-radio-button label="1">上下</el-radio-button>
              <el-radio-button label="0">左右</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="开始按钮X坐标" prop="StartX">
            <el-input-number
                v-model="addForm.StartX"
                :min="0"
                :max="50000"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="开始按钮Y坐标" prop="StartY">
            <el-input-number
                v-model="addForm.StartY"
                :min="0"
                :max="50000"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="webview链接" prop="UrlPath">
            <el-input v-model="addForm.UrlPath" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="虚拟人背景图" prop="BackgroundUrl">
            <el-input v-model="addForm.BackgroundUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="调用大模型地址" prop="AiModelUrl">
            <el-input v-model="addForm.AiModelUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="上传对话内容路径" prop="ContentBackUrl">
            <el-input v-model="addForm.ContentBackUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="空闲几秒退出" prop="FreeTime">
            <el-input-number
                v-model="addForm.FreeTime"
                :min="0"
                :max="300"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="虚拟人包下载地址" prop="AiPackUrl">
            <el-input v-model="addForm.AiPackUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="虚拟人形象地址" prop="HumanUrl">
            <el-input v-model="addForm.HumanUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="虚拟空闲播放视频" prop="HumanVideoUrl">
            <el-input v-model="addForm.HumanVideoUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="数字人模型" prop="AiModelSourceUrl">
            <el-input v-model="addForm.AiModelSourceUrl" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="对话二维码链接" prop="DialogBarCodeUrl">
            <el-input v-model="addForm.DialogBarCodeUrl" auto-complete="off"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closetc">关闭</el-button>
          <el-button
            type="primary"
            @click.native="addSubmit"
            :loading="addLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </section>
  </template>
  
  
  
  <script>
  import { addMachinesConfig,getMachinesConfigByMachineID, BaseApiUrl } from "../../api/api";
  export default {
    props: {
        editForm:{}
    },
    data() {
      return {
        token: {
          Authorization: "Bearer ",
        },
        fileAction: BaseApiUrl + "/images/Upload/PicOne",
        addFormVisible:true,
        options: [],
        addForm: {
          Id:0,
          MachinesID: "",
          Seperate:"0",
          SeperateType:"0",
          DefaultSeperate:0,
          StartX:0,
          StartY:0,
          UrlPath:"",
          BackgroundUrl:"",
          AiModelUrl:"",
          ContentBackUrl:"",
          FreeTime:"5",
          AiPackUrl:"",
          HumanUrl:"",
          HumanVideoUrl:"",
          AiModelSourceUrl:"",
          DialogBarCodeUrl:""
        },
        addLoading: false,
        clinicLoading:false,
        addFormRules: {
         
        },
      };
    },
    methods: {
        remoteMethod(query){  //获取机器分组
            var that = this;
            console.log(111111);
            
            that.clinicLoading = true;
            var para = {
                key: query,
            };
            getMachinesGroupListPage(para).then(res=>{
                console.log("res",res)
                if(res.data.response != null){
                    var result = res.data.response
                    var list =  result.data;
                    that.clinicLoading = false;
                    that.options = result.data;
                    console.log("that.options.length",that.options.length)
                    if(that.options.length == 1){
                        that.addForm.MachinesGroupID = that.options[0].Id;
                    }
                    console.log(that.options);
                }
            });
      },
      closetc(index) { 
        this.$parent.closetc(); //将值传给父组件 
      },
      //新增
      addSubmit: function () {
        let _this = this;
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {}).then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.addForm);
              var user = JSON.parse(window.localStorage.user);
              if (user && user.uID > 0) {
              } else {
                this.$message({
                  message: "用户信息为空，先登录",
                  type: "error",
                });
                _this.$router.replace(
                  _this.$route.query.redirect ? _this.$route.query.redirect : "/"
                );
              }
              
              addMachinesConfig(para).then((res) => {
                this.addLoading = false;
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  }); 
                  this.$parent.closetc(1);
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            });
          }
        });
      },
      getConfig(){
        console.log(this.editForm)
        var machineID = this.editForm.Id;
        console.log(machineID)
        getMachinesConfigByMachineID(machineID).then(res=>{
            console.log("config-result",res)
            this.addForm = Object.assign({}, res.data.response);
        })
        
      }
    },
    mounted() { 
        let tokenStr = window.localStorage.Token;
        this.token = {
            Authorization: "Bearer " + tokenStr,
        };
        this.getConfig();

    },
  };
  </script> 